import React from 'react'
import { classNames } from '../_utils'

const FileFieldIcon = ( { required, noPadding = false, disabled =  false, question = "", name, iconComponent, type =  "text", label, handleChange, handleBlur, value, tooltip, tooltipExplanation } ) => {
  return (
    <div className={ classNames( noPadding ? "flex flex-col items-start h-8" : "flex flex-col items-start my-2 h-8" ) }>
      <p className="text-black py-1 text-xs">
        {question}{ required && ( <span className="text-red-500">*</span>) }<a className="text-xs text-blue-600" href="#" data-toggle="tooltip" rel="tooltip" data-placement="top" title={tooltipExplanation}><i class="fa fa-info-circle">{tooltip}</i></a>
      </p>
      <div className="inline-flex w-full rounded-sm border border-[#1e3a8a]">
          <div className="w-1/6 flex items-center justify-center bg-gray-50">
            <span>{iconComponent}</span>
          </div>
          <input 
            name={name}
            disabled={disabled}
            id={name}
            type="file"
            placeholder={label}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
            autoComplete="off"
            className="w-full px-3 py-1 focus:outline-none focus:text-gray-600 placeholder-black text-sm" 
          />
      </div>
  </div>
  )
}

export default FileFieldIcon